<template>
  <div class="menu-bar">
    <ul class="menu-items">
      <li
        v-for="step in steps"
        :key="step.hash"
        :class="{
          active: stepIsActive(step),
          disabled: step.is_disabled,
          'has-checkbox': step.has_checkbox,
          'has-checkbox--checked': step.is_checked,
        }"
        @click="goToStep(step)"
      >
        <a>{{ step.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { replaceHash } from "@/utils/UrlMutater"

export default {
  name: "StepNavigation",
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    currentHash: null,
  }),
  computed: {
    visibleSteps() {
      return this.steps.filter(step => !step.hidden)
    }
  },
  methods: {
    goToStep(step) {
      const newHash = step.hash || ""
      this.currentHash = newHash
      replaceHash(newHash)
      this.$emit('changed', step)
    },
    navigateToCurrentRoute() {
      this.currentHash = location.hash || ""
    },
    stepIsActive(step) {
      return (step.hash || "") === (this.currentHash || "")
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-items > li {
  cursor: pointer;

  &.disabled {
    background-color: #ddd;
    opacity: 0.5;
    pointer-events: none;
  }

  &.has-checkbox {
    &:after {
      content: "\f134";
      font-family: "Material Design Icons";
      font-size: 16px;
    }
  }

  &.has-checkbox.has-checkbox--checked {
    &:after {
      content: "\f133";
      color: green;
    }
  }
}
</style>
